import {Link} from "gatsby"
import * as React from "react"
import { useGetStats } from '../hooks'

const Stats = ({totalCount, words, mins, minsToWrite}) => {
  return (
    <span style={{display:'none'}}>
      {totalCount} articles
      {words} words
      {mins} mins to read
      {minsToWrite} mins to write
    </span>
  )
}

const Footer = () => {
  const stats = useGetStats()
  return (
    <footer className="blog-footer">
      <div className="footer-content">
        <p>Total Articles Written: <span id="total-articles">{stats.published.totalCount}</span></p>
        <p>Articles in Queue: <span id="articles-queue">{stats.unpublished.totalCount}</span></p>
        <p>Total Time Writing: <span id="writing-time">{stats.published.hrsToWrite} hrs</span></p>
      </div>
      <div className="footer-credit">
        <p>&copy; 2024 <Link to='/'><span className='coffee'>☕</span>Addict.dev</Link></p>
      </div>
    </footer>
  )
}

export default Footer
